import { defineMessage } from 'services/localization';

export const messages = {
    areYouSure: defineMessage('are_you_sure_you_want_t_ove_the_payment_details'),
    cancel: defineMessage('cancel'),
    submit: defineMessage('yes_remove'),
};
